import $ from "jquery";
import "slick-carousel-latest";
import "jquery-match-height";

const $relatedSlider = $( ".js-shoprelated-slider" );

function getSlickSlidesToShow( slick ) {
	let slidesToShow = slick.options.slidesToShow || 1;

	if ( slick.options.responsive ) {
		const windowWidth = $( window ).width();

		slick.options.responsive.forEach( ( breakpoint ) => {
			if ( windowWidth <= breakpoint.breakpoint ) {
				if ( breakpoint.settings.slidesToShow !== undefined ) {
					slidesToShow = breakpoint.settings.slidesToShow;
				}
			}
		} );
	}

	return slidesToShow;
}

function getSlickPageCount( slick ) {
	const slidesToShow   = getSlickSlidesToShow( slick );
	const slidesToScroll = slick.options.slidesToScroll || 1;
	const slideCount     = slick.slideCount;

	if ( slideCount <= slidesToShow ) {
		return 1;
	}

	return Math.ceil( ( slideCount - slidesToShow ) / slidesToScroll ) + 1;
}

function getSlickCurrentPage( slick ) {
	const slidesToScroll = slick.options.slidesToScroll || 1;
	const totalPages     = getSlickPageCount( slick );
	const currentPage    = Math.floor( slick.currentSlide / slidesToScroll ) + 1;

	return Math.min( currentPage, totalPages );
}

function updateShopRelatedPagination( slick ) {
	const $pagination = slick.$slider.closest( ".shoprelated__slider" ).find( ".shoprelated__pagination" );

	$pagination.find( ".js-pagination-slick-current" ).text( getSlickCurrentPage( slick ) );
	$pagination.find( ".js-pagination-slick-total" ).text( getSlickPageCount( slick ) );
}

function setShopRelatedArrowState( slick ) {
	const $pagination = slick.$slider.closest( ".shoprelated__slider" ).find( ".shoprelated__pagination" );
	const $prevBtn    = $pagination.find( ".js-pagination-slick-prev button" );
	const $nextBtn    = $pagination.find( ".js-pagination-slick-next button" );
	const currentPage = getSlickCurrentPage( slick );
	const totalPages  = getSlickPageCount( slick );

	$prevBtn.prop( "disabled", currentPage <= 1 );
	$nextBtn.prop( "disabled", currentPage >= totalPages );
}

if ( $relatedSlider.length ) {
	$relatedSlider.on( "init afterChange breakpoint", function ( event, slick ) {
		updateShopRelatedPagination( slick );
		setShopRelatedArrowState( slick );

    	$('.shoprelated__slider .shopproducts__item').matchHeight();
	} );

	$relatedSlider.slick( {
		slidesToShow: 4,
		slidesToScroll: 1,
		dots: false,
		arrows: true,
		infinite: false,
		prevArrow: ".shoprelated__pagination .js-pagination-slick-prev button",
		nextArrow: ".shoprelated__pagination .js-pagination-slick-next button",
		responsive: [
			{
				breakpoint: 1550,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 1,
				},
			},
			{
				breakpoint: 1199,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 1,
				},
			},
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
				},
			},
		],
	} );
}
